import { Routes } from '@angular/router';

export const bimRoutes: Routes = [
    { path: 'company/:searchTitle', loadComponent: () => import('./company-details/company-details.component').then(m => m.CompanyDetailsComponent) },
    { path: 'company/:searchTitle/:tabName', loadComponent: () => import('./company-details/company-details.component').then(m => m.CompanyDetailsComponent) },
    { path: 'product-details/:searchTitle', loadComponent: () => import('./product-details/product-details.component').then(m => m.ProductDetailsComponent) },
    { path: 'texture-details/:searchTitle', loadComponent: () => import('./texture-details/texture-details.component').then(m => m.TextureDetailsComponent) },
    { path: 'products/:searchTitle', loadComponent: () => import('./searched-product/searched-product.component').then(m => m.SearchedProductComponent) },
    { path: 'category/:searchTitle', loadComponent: () => import('./searched-category/searched-category.component').then(m => m.SearchedCategoryComponent) },
    { path: '', redirectTo: 'home', pathMatch: 'full' }
];

// export const bimRoutesIt: Routes = [
//     { path: 'azienda/:searchTitle', loadComponent: () => import('./company-details/company-details.component').then(m => m.CompanyDetailsComponent) },

//     { path: 'product-details/:searchTitle', loadComponent: () => import('./product-details/product-details.component').then(m => m.ProductDetailsComponent) },
//     { path: '', redirectTo: 'home', pathMatch: 'full' }
// ];

// export const bimRoutesEn: Routes = [
//     { path: 'company/:searchTitle', loadComponent: () => import('./company-details/company-details.component').then(m => m.CompanyDetailsComponent) },

//     { path: 'product-details/:searchTitle', loadComponent: () => import('./product-details/product-details.component').then(m => m.ProductDetailsComponent) },
//     { path: '', redirectTo: 'home', pathMatch: 'full' }
// ];

// export const bimRoutesEs: Routes = [
//     { path: 'empresa/:searchTitle', loadComponent: () => import('./company-details/company-details.component').then(m => m.CompanyDetailsComponent) },

//     { path: 'product-details/:searchTitle', loadComponent: () => import('./product-details/product-details.component').then(m => m.ProductDetailsComponent) },
//     { path: '', redirectTo: 'home', pathMatch: 'full' }
// ];

// export const bimRoutesDe: Routes = [
//     { path: 'unternehmen/:searchTitle', loadComponent: () => import('./company-details/company-details.component').then(m => m.CompanyDetailsComponent) },

//     { path: 'product-details/:searchTitle', loadComponent: () => import('./product-details/product-details.component').then(m => m.ProductDetailsComponent) },
//     { path: '', redirectTo: 'home', pathMatch: 'full' }
// ];

